var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFbDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 3.33301C10.7947 3.33301 3.33301 10.7947 3.33301 19.9997C3.33301 28.318 9.42801 35.213 17.3963 36.4647V24.8163H13.163V19.9997H17.3963V16.328C17.3963 12.1513 19.883 9.84467 23.6913 9.84467C25.5147 9.84467 27.4213 10.1697 27.4213 10.1697V14.2697H25.3213C23.2497 14.2697 22.6047 15.5547 22.6047 16.873V19.9997H27.2263L26.488 24.8163H22.6047V36.4647C30.5713 35.2147 36.6663 28.3163 36.6663 19.9997C36.6663 10.7947 29.2047 3.33301 19.9997 3.33301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFbDark);
export default __webpack_public_path__ + "static/media/ic-fb-dark.c03484f92542fa149758501e7de1dc03.svg";
export { ForwardRef as ReactComponent };